import { isPrimitive } from "./isPrimitive";

const parseSortValue = (val: unknown): number | string => {
  if (val == null) return "";
  const str = isPrimitive(val) ? String(val) : JSON.stringify(val);
  const num = Number(str);
  const date = Date.parse(str);

  if (!isNaN(num) && str.trim() !== "") return num;
  if (!isNaN(date)) return date;
  return str;
};

export const sortByField = <T>(
  data: T[],
  field: keyof T,
  order: "ASC" | "DESC" = "ASC",
): T[] => {
  return [...data].sort((a, b) => {
    const valA = parseSortValue(a[field]);
    const valB = parseSortValue(b[field]);

    let result = 0;
    if (valA > valB) result = 1;
    else if (valA < valB) result = -1;

    return order === "ASC" ? result : -result;
  });
};
